(() => {
  if (window.taffstyleProductTitleFit) return;
  const initialize = () => {
    const title = document.querySelector('#main-product > div > header > .m5, #main-product > header > .m5');
    if (!title || title.dataset.tsTitleFitReady) return;
    title.dataset.tsTitleFitReady = 'true';
    let previousWidth = -1;
    let previousMaximum = -1;
    const fit = () => {
      if (!title.isConnected) { observer.disconnect(); return; }
      const width = title.getBoundingClientRect().width;
      const maximum = matchMedia('(max-width:1000px)').matches ? 20 : 22;
      if (width <= 0 || (width === previousWidth && maximum === previousMaximum)) return;
      previousWidth = width;
      previousMaximum = maximum;
      let low = 12;
      let high = maximum;
      title.style.fontSize = high + 'px';
      const fits = () => title.getBoundingClientRect().height <= parseFloat(getComputedStyle(title).lineHeight) * 2 + 0.5;
      if (fits()) return;
      for (let step = 0; step < 10; step++) {
        const size = (low + high) / 2;
        title.style.fontSize = size + 'px';
        if (fits()) low = size; else high = size;
      }
      title.style.fontSize = Math.floor(low * 10) / 10 + 'px';
    };
    const observer = new ResizeObserver(fit);
    observer.observe(title.parentElement);
    fit();
    if (document.fonts) document.fonts.ready.then(() => { previousWidth = -1; fit(); });
  };
  window.taffstyleProductTitleFit = initialize;
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
